import { FeeRecommendationsFetchError } from '../../../errors/FeeRecommendationsFetchError';
import { MEMPOOL_API_URL } from '../../constants';
import type { FeeRecommendations } from '../../WaasBitcoinWalletProvider.types';

/**
 * Gets fee recommendations from mempool.space API
 *
 * @returns Fee recommendation data with rates in sat/vB
 * @throws FeeRecommendationsFetchError if fetching fee recommendations fails
 */
export const getFeeRecommendations = async (): Promise<FeeRecommendations> => {
  const response = await fetch(`${MEMPOOL_API_URL}/v1/fees/recommended`);

  if (!response.ok) {
    throw new FeeRecommendationsFetchError({ response });
  }

  return response.json();
};
